import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class UserNotificationService {
    private isSpinnerShown$$ = new BehaviorSubject(false);

    get isSpinnerShown$(): Observable<boolean> {
        return this.isSpinnerShown$$.asObservable();
    }

    constructor(
        private toastr: ToastrService,
        private translateService: TranslateService,
    ) {}

    showSuccess(messageKey: string, titleKey = '', shouldTranslate: boolean = true): void {
        this.toastr.success(shouldTranslate ? this.getTranslation(messageKey) : messageKey, shouldTranslate ? this.getTranslation(titleKey) : titleKey);
    }

    showError(messageKey: string, titleKey = '', override?: Partial<IndividualConfig>, shouldTranslate: boolean = true): void {
        setTimeout(() => {
            this.toastr.error(
                shouldTranslate ? this.getTranslation(messageKey) : messageKey,
                shouldTranslate ? this.getTranslation(titleKey) : titleKey,
                override,
            );
        });
    }

    showInfo(messageKey: string, titleKey = '', override?: Partial<IndividualConfig>, shouldTranslate: boolean = true): void {
        this.toastr.info(shouldTranslate ? this.getTranslation(messageKey) : messageKey, shouldTranslate ? this.getTranslation(titleKey) : titleKey, override);
    }

    showWarning(messageKey: string, titleKey = '', override?: Partial<IndividualConfig>, shouldTranslate: boolean = true): void {
        this.toastr.warning(
            shouldTranslate ? this.getTranslation(messageKey) : messageKey,
            shouldTranslate ? this.getTranslation(titleKey) : titleKey,
            override,
        );
    }

    showSpinner(): void {
        this.isSpinnerShown$$.next(true);
    }
    hideSpinner(): void {
        setTimeout((): void => {
            this.isSpinnerShown$$.next(false);
        }, 500); // Adds a 500ms delay to address scenarios where the spinner might not appear at all
        // due to rapid show/hide calls or asynchronous processes causing premature hiding.
        // This ensures the spinner is visible long enough for users to notice before it is hidden.
    }

    private getTranslation(key: string): string {
        return key ? this.translateService.instant(key) : '';
    }
}
